export default "__VITE_ASSET__DgXPDBx___"